<template>
  <div class="" style="width:100%">
    <div class="card-box" v-for="item in list">
      <header class="card-name">
        {{item.name}}
      </header>
       <router-link tag="div" :to="{path:child.path,query:{url: child.url}}" v-for="child in item.children" style="text-align:center">
        <card :title="child.name">
           <div slot="media">
              <img src="../../assets/2.png" style="width: 80%;" alt="" />
           </div>
        </card>
      </router-link>
    </div>
  </div>
</template>

<script>
  import card from 'components/card.vue'
export default {
  data() {
    return {
      currentDate: new Date(),
      list:[]
    };
  },
   components:{
    card: card
  },
   methods: {
      request: function(){
         var vm = this
         vm.list = [
         {
            name:'基础档案',
            children:[
              {name:"产品档案",path:'/xdProduct', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdProduct/toXdProductPage?moduleValue=product&rt=kWS2f8WMmNcw5x65YJMdT4AQMiFT8y3H'},
              {name:"参数设置",path:'/xdParamset',url:'http://pre.xd.imfbp.com/imfbp-loan-web/xdParamset/toXdParamsetPage?moduleValue=paramset&rt=S68s5Q3QrFBzxAKmxFJG35bGkJYTxHB8'}
            ]
          },
          {
            name:'客户管理',
            children:[
              {name:"个人客户管理",path:'/xdPerCust', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdPerCust/toXdPerCustPage?moduleValue=percust&rt=QknJfHwrnfpSxErY8ayESmPJmQpbB6bD'},
              {name:"企业客户管理",path:'/xdEntCust',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdEntCust/toXdEntCustPage?moduleValue=entcust&rt=hTdZswPtYWSdsat6pxp5DxQGFCwmbAjn'}
            ]
          },
          {
            name:'贷前管理',
            children:[
              {name:"贷款申请",path:'/xdPreLoanapp', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdPreLoanapp/toXdPreLoanappPage?moduleValue=loanapp&rt=5WpiRkMRza2XWFsJZfKEpFSDajG5ekBD'},
              {name:"尽职调查",path:'/xdPreLoandoc',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdPreLoandoc/toXdPreLoandocPage?moduleValue=loandoc&rt=3aQhys8CNaJDXRbXaFEAiYs6hxp8sxMk'}
            ]
           },
           {
            name:'贷中管理',
            children:[
              {name:"上会审批",path:'/xdLoanTask', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanTask/toXdLoanTaskPage?moduleValue=loantask&rt=ap4YeniSQ4tcZwaaKGcaJh2JSz5SxrFE'},
              {name:"贷款合同",path:'/xdLoanContract',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanContract/toXdLoanContractPage?moduleValue=loancont&rt=cQjAX5ihPzCZendMKtdHkrKMpxYNnjJH'},
              {name:"放款审批",path:'/xdLoanDuebill',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanDuebill/toXdLoanDuebillPage?moduleValue=duebill&rt=W7K7NiamiFPKJeRJJsBY5rEFeZY5HjMp'}
            ]
           },
           {
            name:'贷后管理',
            children:[
              {name:"贷款计算器",path:'/xdInterestCalctor', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdInterestCalctor/toXdInterestCalctorPage?moduleValue=calcutor&rt=fHRfbiEPRhzXXFFQtpkHPHZ74Xyk8hGi'},
              {name:"贷款还款计划",path:'/xdLoanPayplan', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanPayplan/toXdLoanPayplanPage?moduleValue=payplan&rt=pssEnt2MWCkCCDB2F2rKEm3AXYmb5ZAP'},
              {name:"贷后监查",path:'/xdLoanMonite', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanMonite/toXdLoanMonitePage?moduleValue=monitor&rt=5Bm6nfWiT755BFQxejGSf6znH6D3P75Y'},
              {name:"贷款五级分类",path:'/xdLoanFivestatus', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanFivestatus/toXdLoanFivestatusPage?moduleValue=fivestatus&rt=y47mD3B82X2Ax2j3SJ3pHF6QfDMdPhrw'},
              {name:"提前还本",path:'/xdRepaymentPrincipal', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdRepaymentPrincipal/toXdRepaymentPrincipalPage?moduleValue=principle&rt=JGTjapPybMGeZZ6J53yhA5natAPzY4F3'},
              {name:"罚息处理",path:'/xdLoanProcess', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanProcess/toXdLoanProcessPage?moduleValue=process&rt=4z5M8M7iZnx4zYEiyRnF86EsdG7sTwMi'},
              {name:"收款登记",path:'/xdLoanPayment', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdLoanPayment/toXdLoanPaymentPage?moduleValue=payment&rt=ty2YfT3Ffi4AZQMwYzCy85ZbZtybTbkW'},
              {name:"合同变更",path:'/xdContractChange', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdContractChange/toXdLoanContractPage?moduleValue=contchange&rt=KYn4cianf8WcQb2M6zB7S4fJJjfhiDTQ'},
              {name:"利率变更",path:'/xdRateChange', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdRateChange/toXdRateChangePage?moduleValue=ratechange&rt=Xm55GaQscPPXtEy8S7ZXJREasXyBhWrQ'},
              {name:"合同展期",path:'/xdContractRenewal', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdContractRenewal/toXdContractRenewalPage?moduleValue=extend&rt=ThSikrpwnEKtkjzQcYYyfWByhrtKp6Pe'},
              {name:"合同结束",path:'/xdContractEnd', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdContractEnd/toXdContractEndPage?moduleValue=contend&rt=8QBRpt32xSzFADXACFWmG7mB5zrPQtkB'}
            ]
          },
          {
             name:'报表',
             children:[
               {name:"贷款项目进度",path:'/loanItemReport', url:'http://pre.xd.imfbp.com/imfbp-loan-web//loanItemReport/toLoanItemReportPage?moduleValue=loanitemreport&rt=QFeRE5b7t8NnD7QAMa8WSm836tK7Exa6'},
               {name:"贷款合同台账",path:'/xdContractReport',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdContractReport/toXdContractReportPage?moduleValue=loancontreport&rt=TRZxBzxmwm2EFbmPcrBZFMe77ERMFhwF'},
               {name:"客户台账明细",path:'/xdCustTallyDetail',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdCustTallyDetail/toXdCustTallyDetailPage?moduleValue=custdetailreport&rt=YjTZSRsDDFCQTXcB3wGFADp64QnZRk7K'},
               {name:"客户台账余额",path:'/xdCustTallyBalance',url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdCustTallyBalance/toxdCustTallyBalancePage?moduleValue=custbalancereport&rt=6w3isXGReQaCzf7nhPka3PxQxyJK5b3S'}
             ]
            },
          ]

      },
      opentab: function(child){
        var path = child.path;
        console.log('path:'+path);
        this.$router.push({path:path,query:{url: child.url}});

      }
    },

    created: function(){
      this.request()
    }
}
</script>

<style>
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 50%;
    display: block;
    margin: 0 auto;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>
 No newline at end of file



// WEBPACK FOOTER //
// index.vue?7f697a4a